import { Player } from "@lottiefiles/react-lottie-player";
import React, { useEffect, useRef } from "react";
import { ImageObject } from "../types/FeatureModuleDetail";

type ImageMobileType = {
  backgroundColor: string;
  imageObject: ImageObject;
};

const ImageMobile: React.FC<ImageMobileType> = ({
  backgroundColor,
  imageObject,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const playerRef = useRef<Player>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio >= 1) {
          playerRef.current?.play();
        }
      },
      {
        threshold: [1],
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [ref]);

  return (
    <div
      className={`feature-module__image h-[360px] flex justify-center items-center w-full rounded-3xl p-8 mb-10 md:mb-8 sm:mb-6 sm:p-5 sm:h-auto`}
      style={{
        backgroundColor,
      }}
    >
      {imageObject?.lottie ? (
        <div className={`h-full w-full container-lottie-aspect`} ref={ref}>
          <Player
            keepLastFrame
            autoplay={false}
            loop={imageObject?.lottieLoop}
            src={imageObject?.lottie}
            className={`h-full object-contain`}
            ref={playerRef}
          />
        </div>
      ) : (
        <img
          src={imageObject?.image}
          alt={imageObject?.imageAltText}
          className={`h-full object-contain`}
        />
      )}
    </div>
  );
};

export default ImageMobile;
